import React from "react";
import { UserContextValue } from "./types";

export default React.createContext<UserContextValue>({ isLoading: true });
